import * as yup from "yup";

export const VendorValidationSchema = yup.object().shape({
    name: yup.string().max(50, "Name not more than 50 Characters.").required("Name is Required"),
    contact_person: yup.string().max(50, "Name not more than 50 Characters.").required("Contact Person is Required"),
    phone: yup.string().max(15, "Phone not more than 15 Characters.").required("Phone is Required"),
    email: yup.string().max(50, "Email not more than 50 Characters."),
    address: yup.string().max(250, "Address not more than 250 Characters.").required("Address is Required"),
});
